import * as MesAnoActions from '../actions/mes-ano.action';
import { MesAnoModel } from '../models/mes-ano.model';

export const mesAno: MesAnoModel = new MesAnoModel();

export function mesAnoReducer(state = mesAno, action: MesAnoActions.Actions) {
    switch (action.type) {
        case MesAnoActions.ADD_MES_ANO:
            {
                state = action.payload;
                return state;
            };

        case MesAnoActions.CLEAR_MES_ANO:
            {
                state = new MesAnoModel();
                return state;
            }

        default:
            return state;
        }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/reducers/mes-ano.reducer.ts